import { Row } from 'app/design/primitives/box';
import type { useDesktopLandingData } from '../use-desktop-landing-data';
import { DefricheurCard, ReferralInviteCard } from './immature-neighbourhood';

export function ImmatureNeighbourhoodActions({
  neighbourhoodStatus,
}: {
  neighbourhoodStatus: NonNullable<ReturnType<typeof useDesktopLandingData>['neighbourhoodStatus']>;
}) {
  if (!neighbourhoodStatus.defricheurEligible && !neighbourhoodStatus.referral) return null;
  return (
    <Row gap="spacing.general.x4" alignItems="stretch">
      {neighbourhoodStatus.defricheurEligible ? <DefricheurCard /> : null}
      {neighbourhoodStatus.referral ? <ReferralInviteCard referral={neighbourhoodStatus.referral} /> : null}
    </Row>
  );
}
